export enum VisitorType {
    VISITOR = 'VISITOR', VISITORGROUP = 'VISITORGROUP'
}

export class TypeFilter {

    /** Uniquely identifies a quickfilter. */
    id: string;
    /** css style of image show for this filter. */
    icon: string;
    /** dictionary key used as tooltip. */
    title: string;
    /** if this filter is currently selected. */
    selected: boolean;

    visitorType: VisitorType;
}

export class VisitorUpfrontRegistationFilterModel {
    filterText = '';
    visitorTypes = new Array<VisitorType>();
}

export class VisitReservation {

    id: number;
    visitorId: number;
    name: string;
    firstname: string;
    visitorType: VisitorType;
    company: string;
    plannedArrival: string;
    plannedArrivalSortValue: number;
    arrival: string;
    arrivalSortValue: number;
    leave: string;
    leaveSortValue: number;
    numberPlate: string;
    rowStyle: string;
    hintStyle: string;
    reason: string;
    notes: string;
    inRegularIntervals: boolean;
    searchText: string;
    visitedPersonString: string;
    // messagingProviderKey: string;
    useGlobalConnect: boolean;
    registrationCode: string;
    role: string;
    roleDictionaryKey: string;
    invitationSentDate: string;
    invitationSentDateSortValue: number;
}
